import axios from 'axios';

import config from '../../../config/config';
import { history } from '../../../Router';
import {
  getApiTokensInLocalStorage,
  getHsEmailInLocalStorage,
  getHsOwnerIdInLocalStorage,
  getImpersonatedUserIdInLocalStorage,
  clearAuthenticationInLocalStorage,
} from '../../localStorage/localStorage';
import { endpoints } from '../endpoints';
import { createTassoQuintoSession } from './tassoQuintoSession';

const commonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const exchangeClient = axios.create({
  baseURL: config.serverBasePath,
  headers: commonHeaders,
  timeout: config.networkTimeout,
  withCredentials: false,
});

exchangeClient.interceptors.request.use((request) => {
  const accessToken = getApiTokensInLocalStorage()?.access.token;
  if (accessToken) {
    request.headers.set('Authorization', `Bearer ${accessToken}`);
  }
  return request;
});

const tassoQuintoClient = axios.create({
  baseURL: config.tassoQuintoApiBaseUrl,
  headers: commonHeaders,
  timeout: config.networkTimeout,
  withCredentials: false,
});

const getImpersonatedUserIdForExchange = () => {
  const impersonatedUserId = getImpersonatedUserIdInLocalStorage();
  if (
    (getHsOwnerIdInLocalStorage() || getHsEmailInLocalStorage()) &&
    !impersonatedUserId
  ) {
    throw new Error('Impersonation user id is missing');
  }
  return impersonatedUserId;
};

const session = createTassoQuintoSession({
  apiClient: tassoQuintoClient,
  exchangeClient,
  exchangePath: endpoints.auth.tassoQuintoToken,
  getImpersonatedUserId: getImpersonatedUserIdForExchange,
  onExchangeUnauthorized: async () => {
    clearAuthenticationInLocalStorage();
    if (history?.navigate) {
      await history.navigate('/login');
    }
  },
});

export const axiosTassoQuintoApiInstance = session.apiClient;
export const clearTassoQuintoSession = session.clear;
export {
  classifyTassoQuintoError,
  getTassoQuintoErrorCode,
  getTassoQuintoErrorDetails,
  getTassoQuintoErrorFields,
  getTassoQuintoErrorStatus,
  isHubspotOwnerMissingError,
} from './tassoQuintoErrors';
export type { TassoQuintoErrorKind } from './tassoQuintoErrors';
